const reportTimezoneSuffixPattern = /\s*(?:UTC|GMT|WIB|WITA|WIT|[+-]\d{2}:?\d{2}|Z)$/i;
const reportUTCStyleSuffixPattern = /\s*(?:UTC|GMT|[+-]00:?(?:00)?|Z)$/i;

const reportDateTimeFormatter = new Intl.DateTimeFormat('id-ID', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const parseAsLocalWallClock = input => {
  const normalized = String(input || '')
    .trim()
    .replace(reportTimezoneSuffixPattern, '')
    .replace(' ', 'T');
  const match = normalized.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?)?$/
  );

  if (!match) {
    return null;
  }

  const [, year, month, day, hour = '0', minute = '0', second = '0'] = match;
  const parsed = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second)
  );

  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const parseReportDateTime = value => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'number') {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const raw = String(value).trim();
  if (!raw) {
    return null;
  }

  const looksLikeDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(raw);
  if (looksLikeDateOnly) {
    return parseAsLocalWallClock(raw);
  }

  const looksLikeDateTime = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}/.test(raw);
  if (looksLikeDateTime && (!reportTimezoneSuffixPattern.test(raw) || reportUTCStyleSuffixPattern.test(raw))) {
    const parsedLocal = parseAsLocalWallClock(raw);
    if (parsedLocal) {
      return parsedLocal;
    }
  }

  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) {
    return parseAsLocalWallClock(raw);
  }

  return parsed;
};

export const getReportDateTimestamp = value => {
  const parsed = parseReportDateTime(value);
  return parsed ? parsed.getTime() : 0;
};

export const formatReportDateTime = value => {
  const parsed = parseReportDateTime(value);
  return parsed ? reportDateTimeFormatter.format(parsed) : '-';
};
